import React, { useEffect } from "react"
import { COPY_STRINGS } from "../../../../constants/translatedCopy"
import { delay } from "../../../../services/util"
import { amiraGestures } from "../../../Coach/GesturedSpeech"
import { isChromeDesktop, isEdgeDesktop, isFirefoxDesktop, isSafariDesktop } from "../../functions/browserChecks"
import { studentInProductHelpLinks } from "../../../../constants/helpLinks"
import StudentInstruction from '../../Components/StudentInstruction'
import RaiseHand from '../../Components/PreCheckIllustrations/RaiseHand'
import { GetBrandedTutorName } from "../../../../services/BrandingService"

export default React.memo(function InstructToFixPermission(props) {

    const { speechProps, toggleReaderContainer } = props

    useEffect(() => {
        toggleReaderContainer()
        speechProps.abortDance()
        const speechPattern = async () => {
            speechProps.playDance({
                gesture: amiraGestures.Playful_nomouth,
            })
            await speechProps.speakWithPromise({
                textToSpeak: COPY_STRINGS.student_checks.student_hardware_denied,
            })
            speechProps.abortDance();
            speechProps.playDance({
                gesture: amiraGestures.PointingWithChalk
            })
            await speechProps.speakWithPromise({
                textToSpeak: COPY_STRINGS.student_checks.student_hardware_denied_two,
            })
            speechProps.abortDance();
          }
        speechProps.abortSpeech(speechPattern)

        return () => {
            toggleReaderContainer()
        }
    }, [])

    const getMicHelpLink = () => {
        if(isChromeDesktop()) return studentInProductHelpLinks.enableMicrophoneChromeDesktop
        if(isFirefoxDesktop()) return studentInProductHelpLinks.enableMicrophoneFirefoxDesktop
        if(isSafariDesktop()) return studentInProductHelpLinks.enableMicrophoneSafariDesktop
        if(isEdgeDesktop()) return studentInProductHelpLinks.enableMicrophoneEdgeDesktop
        return studentInProductHelpLinks.enableMicrophoneGeneral
    }

    return <div>
        <StudentInstruction>
            <RaiseHand/>
            <p>{GetBrandedTutorName()} needs access to the microphone to listen to your student read. Please follow the instructions at this <a target="_blank" href={getMicHelpLink()}>microphone help link</a> to enable microphone access.</p>
        </StudentInstruction>
    </div>

})